module.exports = __webpack_public_path__ + "media/images/user-d8c09ca909e4371c2f5222d5b90348c0.png";